import { render, staticRenderFns } from "./AddToDatasetDialog.vue?vue&type=template&id=67e12685&scoped=true&"
import script from "./AddToDatasetDialog.vue?vue&type=script&lang=js&"
export * from "./AddToDatasetDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddToDatasetDialog.vue?vue&type=style&index=0&id=67e12685&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e12685",
  null
  
)

export default component.exports